const notes = {
  title: 'Título',
  details: 'Detalles',
  content: 'Contenido',
  showForm: 'Nueva nota',
  to: { label: 'Hacia', validation: 'Hacia es obligatorio' },
  addNote: 'Añadir',
  cancel: 'Cancelar',
  save: 'Guardar',
  createdAt: 'Creado en: ',
  createdBy: 'Creado por: ',
  noteType: 'Tipo de nota ',
  typeNewNote: 'Escriba una nueva nota ...',
  dropDownIcons: {
    pinToTop: 'Anclar en la parte superior',
    unpinFromTop: 'Desanclar de la parte superior',
    EditUpdate: 'Editar actualización',
    DeleteUpdate: 'Eliminar la actualización de evryone',
  },
  edit: {
    toast: {
      error: {
        delete: 'La nota no se eliminó',
        add: 'La nota no se añadió',
        update: 'La nota no se actualizó',
        pin: 'La nota no está anclada en la parte superior',
        unpin: 'La nota no se desató de la parte superior',
      },
    },
  },
};

export default notes;
